// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-container.populated label[data-v-fc30a106],\n.input-container:focus-within label[data-v-fc30a106] {\n  padding-top: 0.25rem;\n  font-size: 0.75rem;\n}\n.input-container.populated .textarea-container[data-v-fc30a106],\n.input-container:focus-within .textarea-container[data-v-fc30a106] {\n  padding-top: 1.5rem;\n  padding-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
